import React, { useState } from 'react';
import ReactDom from 'react-dom';
import { Button } from 'lib/components';
import { TextField } from 'lib/components/FormFields';
import classes from './index.module.scss';

/**
 * Props for the AddNoteModal component
 */
interface Props {
	isOpen: boolean; // Controls visibility of the modal
	onClose: () => any; // Callback function when modal is closed
	onAddNote: (message: string) => void; // Callback function when a note is added
}

/**
 * Modal component for adding notes to a job
 * Renders a form with a text area for entering the note message
 *
 * @param isOpen - Controls visibility of the modal
 * @param onClose - Callback function when modal is closed
 * @param onAddNote - Callback function when a note is added
 */
const AddNoteModal = ({ isOpen, onClose, onAddNote }: Props) => {
	// State for the note message text
	const [message, setMessage] = useState('');

	// Don't render anything if the modal is not open
	if (!isOpen) {
		return null;
	}

	return ReactDom.createPortal(
		<div className={classes['add-note-modal']}>
			<div className={classes['add-note-modal-content']}>
				<div className={classes['add-note-modal-items']}>
					<div className={classes['add-note-modal-form']}>
						<TextField
							placeholder="Enter your message"
							label="Message (required)"
							variant="labelled"
							textArea
							rows={9}
							value={message}
							onChange={(e) => setMessage(e.target.value)}
						/>
					</div>
					<div className={classes['add-note-modal-footer']}>
						{/* Add Note button - disabled if message is empty */}
						<Button
							variant="standard"
							color="primary"
							title="Add Note"
							style={{
								marginRight: '1rem',
							}}
							disabled={message === ''}
							onClick={() => {
								onAddNote(message);
								setMessage('');
								onClose();
							}}
						/>
						{/* Cancel button - closes the modal without adding a note */}
						<Button
							variant="standard"
							color="gray"
							sizing="small"
							title="Cancel"
							onClick={() => {
								setMessage('');
								onClose();
							}}
						/>
					</div>
				</div>
			</div>
		</div>,
		document.getElementById('portal') as HTMLElement
	);
};

export default AddNoteModal;
